import { IAbstractRecord } from '@models';
import { IMotorLovs, IPolicyMotorDetails } from '.';
import { lookupListAsRecordObject } from '@utils/graph-utils';

export function mapToPolicyMotorDetails(data: IAbstractRecord): {
  mappedData: IPolicyMotorDetails;
  lovs: IMotorLovs;
} {
  const motorDetails = data.Production.queries.getPolicyMotorDetails[0];

  const mappedData: IPolicyMotorDetails = {
    nameOnLicenseEn: motorDetails.production_PolicyMotor_NameOnLicenseEn,
    nameOnLicenseAr: motorDetails.production_PolicyMotor_NameOnLicenseAr,
    vignetteCode: motorDetails.production_PolicyMotor_VignetteCode,
    vignette: motorDetails.production_PolicyMotor_Vignette,
    plateCode: motorDetails.vehicle_PlateCode,
    plateNumber: motorDetails.vehicle_PlateNumber,
    usageType: motorDetails.vehicle_UsageType,
    bodyType: motorDetails.vehicle_BodyType,
    engineType: motorDetails.vehicle_EngineType,
    make: motorDetails.vehicle_Make,
    model: motorDetails.vehicle_Model,
    color: motorDetails.vehicle_Color,
    yearOfMake: motorDetails.vehicle_YearOfMake,
    engine: motorDetails.vehicle_Engine,
    weight: motorDetails.vehicle_Weight,
    engineSize: motorDetails.vehicle_EngineSize,
    seatingCapacity: motorDetails.vehicle_SeatingCapacity,
    chassis: motorDetails.vehicle_Chassis,
    horsePower: motorDetails.vehicle_HorsePower,
    carValue: motorDetails.vehicle_CarValue,
    agencyRepairYear: motorDetails.production_PolicyMotor_AgencyRepairYear,
    depreciationYears: motorDetails.production_PolicyMotor_DepreciationYears,
  };

  const lovs: IMotorLovs = {
    bodyTypes: lookupListAsRecordObject(
      data.Insurance.lookups.bodyTypes,
      false,
      'Code',
      'Title'
    ),
    brands: lookupListAsRecordObject(
      data.Insurance.lookups.brands,
      false,
      'Code',
      'Title'
    ),
    colors: lookupListAsRecordObject(
      data.Core.lookups.colors,
      false,
      'Code',
      'Title'
    ),
    engineTypes: lookupListAsRecordObject(
      data.Insurance.lookups.engineTypes,
      false,
      'Code',
      'Title'
    ),
    plateCodes: lookupListAsRecordObject(
      data.Insurance.lookups.plateCodes,
      false,
      'Code',
      'Title'
    ),
    usageTypes: lookupListAsRecordObject(
      data.Insurance.lookups.usageTypes,
      false,
      'Code',
      'Title'
    ),
  };

  return { mappedData, lovs };
}
